import { useEffect, useState } from 'react';
import Dexie, { liveQuery } from 'utils/database';

class CartDatabase extends Dexie {
  constructor() {
    super('CartDB');
    this.version(1).stores({
      items: '++, &id, productId, userId', // invisible autoincrement primary key and indexed props
    });
  }
}

const db = new CartDatabase();

export default db;

export const useCartDatabase = (
  query,
  deps = [],
  defaultValue = null,
  transform = value => value,
) => {
  const [data, setData] = useState({ isLoading: true, value: transform(defaultValue) });

  useEffect(() => {
    const subscription = liveQuery(query).subscribe(value => {
      setData({ isLoading: false, value: transform(value) });
    });

    return () => {
      subscription.unsubscribe();
    };
  }, deps);

  return { isLoading: data.isLoading, data: data.value };
};
